/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SmtpAuthentication } from './SmtpAuthentication';
import {
    SmtpAuthenticationFromJSON,
    SmtpAuthenticationFromJSONTyped,
    SmtpAuthenticationToJSON,
} from './SmtpAuthentication';

/**
 * SMTP settings
 * @export
 * @interface SmtpSettings
 */
export interface SmtpSettings {
    /**
     * 
     * @type {string}
     * @memberof SmtpSettings
     */
    host?: string;
    /**
     * 
     * @type {number}
     * @memberof SmtpSettings
     */
    port?: number;
    /**
     * 
     * @type {string}
     * @memberof SmtpSettings
     */
    from?: string;
    /**
     * 
     * @type {string}
     * @memberof SmtpSettings
     */
    fromName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SmtpSettings
     */
    authenticationNeeded?: boolean;
    /**
     * 
     * @type {SmtpAuthentication}
     * @memberof SmtpSettings
     */
    authentication?: SmtpAuthentication;
    /**
     * 
     * @type {boolean}
     * @memberof SmtpSettings
     */
    ssl?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SmtpSettings
     */
    starttls?: boolean;
}

/**
 * Check if a given object implements the SmtpSettings interface.
 */
export function instanceOfSmtpSettings(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SmtpSettingsFromJSON(json: any): SmtpSettings {
    return SmtpSettingsFromJSONTyped(json, false);
}

export function SmtpSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SmtpSettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'host': !exists(json, 'host') ? undefined : json['host'],
        'port': !exists(json, 'port') ? undefined : json['port'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'fromName': !exists(json, 'fromName') ? undefined : json['fromName'],
        'authenticationNeeded': !exists(json, 'authenticationNeeded') ? undefined : json['authenticationNeeded'],
        'authentication': !exists(json, 'authentication') ? undefined : SmtpAuthenticationFromJSON(json['authentication']),
        'ssl': !exists(json, 'ssl') ? undefined : json['ssl'],
        'starttls': !exists(json, 'starttls') ? undefined : json['starttls'],
    };
}

export function SmtpSettingsToJSON(value?: SmtpSettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'host': value.host,
        'port': value.port,
        'from': value.from,
        'fromName': value.fromName,
        'authenticationNeeded': value.authenticationNeeded,
        'authentication': SmtpAuthenticationToJSON(value.authentication),
        'ssl': value.ssl,
        'starttls': value.starttls,
    };
}

